import './Mundo.css';

function Mundo() {
  return (
    <section className="mundo-section py-5">
      <div className="container animate-on-scroll">
        <div className="row align-items-center justify-content-center">

          {/* Columna del icono */}
          <div className="col-md-4 text-center mb-4 mb-md-0">
            <img src="/img/Mundo.png" alt="Mundo" className="img-fluid mundo-icon" />
          </div>

          {/* Columna del texto */}
          <div className="col-md-8">
            <div className="mundo-text">
              <h3 className="fw-bold mb-3 text-primary">Conectados sin importar la distancia</h3>
              <p className="text-muted fs-5 text-justify">
                No importa dónde estés, nos adaptamos a tu ubicación. Trabajamos contigo de forma remota o presencial, 
                con total cercanía y compromiso. En Code Nest Dev, tu proyecto puede empezar desde cualquier rincón del mundo.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Mundo;
